export default __webpack_public_path__ + "static/media/logo_marketing.1956a685.svg";